/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import $ from 'jquery';
import Component from 'can/component/component';
import template from './dropdown-container.stache';
import dropdownItemView from 'components/dropdown/dropdown-item/dropdown-item.stache';
import appContext from 'scripts/app-context';
import can from 'can';
import DomEventsManager from 'scripts/dom-events-manager';
import DropdownSearch from 'components/dropdown/dropdown-container/dropdown-search';
import domUtil from 'scripts/utils/dom';

var isExtraSmallScreen = false;

Component.extend({
    tag: 'dropdown-container',
    template: template,
    leakScope: false,
    viewModel: {
        value: null,
        title: '',
        define: {
            search: {
                Type: DropdownSearch,
                Value: null
            },
            searchValue: {
                type: 'string',
                value: ''
            },
            label: {
                type: 'string',
                value: null
            },
            alignRight: {
                type: 'htmlbool',
                value: false
            },
            items: {
                Type: can.List,
                Value: can.List
            },
            moreDropdownItems: {
                Type: can.List,
                Value: can.List
            },
            isSelectedMoreItem: {
                type: 'boolean',
                value: false
            },
            links: {
                Type: can.List,
                Value: can.List
            }
        },
        filterItems(value) {
            this.attr('searchValue', value);
        }
    },
    events: {
        inserted(element) {
            this.dropdownContainer = element.find('.c-dropdown');
            this.updateTitle(this.viewModel.attr('value'));
            this.viewModel.bind('value', (event, value) => {
                this.updateTitle(value);
                this.viewModel.dispatch({type: 'onChange', payload: {value: value}});
            });

            this.viewModel.attr('items').bind('add', () => {
                this.updateTitle();
            });

            setTimeout(() => {
                this.filterItemsMap = [];
                this.$moreItem = this.dropdownContainer.find('.js-more-item');
                this.$moreDropdownList = this.$moreItem.find('.s-more-dropdown-list');
                const filters = this.dropdownContainer.find('.js-dropdown-list__item');
                this.itemsNumber = this.viewModel.attr('items').length;
                this.$wrapEl = this.dropdownContainer.find('.s-filter-dropdown');

                filters.each((index, el)=> {
                    this.filterItemsMap.push(el);
                });
            }, 0);
            setTimeout(() => {
                if (isExtraSmallScreen) {
                    domUtil.trapFocusMultiplatform(this.$wrapEl);
                }
            }, 500);
            DomEventsManager.subscribe(this);
        },

        onLayout(screen) {
            isExtraSmallScreen = screen === 'extra-small';
            if (screen === 'large' || screen === 'extra-large') {
                setTimeout(() => {
                    this.checkItemsCount();
                }, 0);
            } else {
                this.viewModel.attr('moreDropdownItems', null);
                this.viewModel.attr('isFit', false);
            }
        },

        checkItemsCount: function () {

            if (this.viewModel.attr('items').length == 0) {
                return;
            }
            const filtersWidth = this.dropdownContainer.width();
            const moreItemWidth = this.$moreItem.outerWidth(true);
            let menuItemsWidth = 0;
            this.viewModel.attr('moreDropdownItems', null);
            this.$moreDropdownList.html('');
            let isFit = true;

            this.filterItemsMap.forEach((el, index) => {

                if (isFit) {
                    const itemWidth = $(el).outerWidth(true);
                    if (menuItemsWidth + itemWidth + (index===this.itemsNumber-1 ? 0 : moreItemWidth) <= filtersWidth) {
                        this.viewModel.attr('items')[index].attr('isFit', true);

                        menuItemsWidth +=itemWidth;
                    } else {
                        let item = this.viewModel.attr('items')[index];
                        item.attr('isFit', false);
                        this.viewModel.attr('moreDropdownItems').push(item);
                        isFit = false;
                    }
                } else {
                    let item = this.viewModel.attr('items')[index];
                    item.attr('isFit', false);
                    this.viewModel.attr('moreDropdownItems').push(item);
                    this.viewModel.attr('dropdownMore', true);
                }
            });

            this.viewModel.attr('isFit', isFit);

            this.viewModel.attr('moreDropdownItems').forEach((item)=>{
                this.$moreDropdownList.append(dropdownItemView(item));
            });
        },

        closeDropdown() {
            this.dropdownContainer.removeClass('is-opened');
            if (appContext.model.screen.attr('screenSize') === 'extra-small') {
                appContext.model.dispatch('page-scroll-toggle', [false]);
            }
        },

        updateTitle(value) {

            const checkValue = value || this.viewModel.attr('value');
            //after rendering all items and links
            setTimeout(() => {
                can.batch.start();
                this.viewModel.attr('items').forEach((item) => {
                    item.attr('selected', false);
                    $(item).find('.js-dropdown-aria-select').attr('aria-selected', false);
                    if (item.attr('value') === checkValue) {
                        item.attr('selected', true);
                        $(item).find('.js-dropdown-aria-select').attr('aria-selected', true);
                        this.viewModel.attr('title', item.attr('title'));
                    }
                });
                this.viewModel.attr('links').forEach((item) => {
                    if (item.attr('isActive')) {
                        this.viewModel.attr('title', item.attr('title'));
                    }
                });

                can.batch.stop();
            }, 0);
        },

        '{scope} searchValue'(scope, event, searchValue) {
            const filter = this.viewModel.attr('search.filter');
            if (filter) {
                can.batch.start();
                this.viewModel.attr('items').forEach((item)=> {
                    item.attr('display', filter(item.attr('value'), searchValue));
                });
                this.viewModel.attr('links').forEach((item)=> {
                    item.attr('display', filter(item.attr('value'), searchValue));
                });
                can.batch.stop();
            }
        },

        '.js-dropdown-list__item click'(element) {
            const target = $(element.context);
            const value = target.data('value');
            this.updateTitle(value);

            this.viewModel.attr('isSelectedMoreItem', target.closest('.js-more-item').length);

            this.closeDropdown();
            setTimeout(() => {
                this.viewModel.attr('value', value);
                if (appContext.model.screen.attr('screenSize') === 'large' || appContext.model.screen.attr('screenSize') === 'extra-large') {
                   this.checkItemsCount();
                }
            }, 0);
        },

        'dropdown-link click'(element) {
            this.closeDropdown();
        },

        '.js-selected-item click'(element, event) {
            this.dropdownContainer.toggleClass('is-opened');

            if (appContext.model.screen.attr('screenSize') === 'extra-small') {
                appContext.model.dispatch('page-scroll-toggle', [true]);
            }
        },

        '.s-btn-close click'() {
            this.closeDropdown();
            appContext.model.dispatch('page-scroll-toggle', [false]);
        },

        '{document} click'(element, event) {
            if (this.dropdownContainer.hasClass('is-opened')) {
                if (!this.element.get(0).contains(event.target)) {
                    this.closeDropdown();
                }
            }
        }
    }
});